import moment from "moment";

// Backend dates are wall-clock strings without a timezone
// ("2026-10-02T14:00:00"). moment parses those as local time, and we send them
// back in the same shape — never toISOString(), which would shift to UTC.
export const toApiDateTime = (date) =>
  date ? moment(date).format("YYYY-MM-DDTHH:mm:00") : null;

export const formatDateTime = (value) =>
  value ? moment(value).format("DD.MM.YYYY HH:mm") : "-";

// Mirrors the backend: FinishDate = StartDate + (WeekCount × 7 days).
export const computeFinishDate = (startDate, weekCount) =>
  startDate && weekCount > 0
    ? moment(startDate).add(weekCount * 7, "days").toDate()
    : null;

// Whole weeks between two dates, at least 1 (used to prefill "Süre Güncelle").
export const weeksBetween = (start, end) => {
  if (!start || !end) return 1;
  const days = moment(end).diff(moment(start), "days");
  return Math.max(1, Math.round(days / 7));
};

// Display status of a coaching record. Open records (RowStatus true) can still
// be closed/extended even when expired or not yet started.
export const CoachingState = {
  Active: "active",
  Upcoming: "upcoming",
  Expired: "expired",
  Closed: "closed",
};

export const getCoachingState = (coaching) => {
  if (!coaching.RowStatus) return CoachingState.Closed;
  const now = moment();
  if (coaching.EndDate && moment(coaching.EndDate).isBefore(now))
    return CoachingState.Expired;
  if (coaching.StartDate && moment(coaching.StartDate).isAfter(now))
    return CoachingState.Upcoming;
  return CoachingState.Active;
};

export const CoachingStateLabel = {
  [CoachingState.Active]: "Aktif",
  [CoachingState.Upcoming]: "Başlamadı",
  [CoachingState.Expired]: "Süresi Doldu",
  [CoachingState.Closed]: "Kapalı",
};
